module.exports = __webpack_public_path__ + "assets/img/btn-view-d8bd81b9.png";